import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
  modal: {
    width: '100%',
    height: '100%',
    position: 'absolute',
    borderWidth: 0,
  },
  container: {
    flex: 1,
    backgroundColor: 'rgba(0,0,0,0.60)',
  },
  modalBox: {
    width: '100%',
    height: '100%',
    position: 'absolute',
    justifyContent: 'center',
  },
  modalContentLarge: {
    backgroundColor: '#fff',
    width: '50%',
    height: '55%',
    alignSelf: 'center',
    justifyContent: 'center',
    borderRadius: 30,
  },

  modalLandscape: {
    backgroundColor: '#fff',
    width: '50%',
    height: '80%',
    alignSelf: 'center',
    justifyContent: 'center',
    borderRadius: 30,
  },
  modalContentSmall: {
    backgroundColor: '#fff',
    width: 300,
    height: 300,
    alignSelf: 'center',
    justifyContent: 'center',
    borderRadius: 30,
  },
  modaIconContainer: {
    position: 'absolute',
    top: -30,
    zIndex: 100,
    borderRadius: 35,
    alignSelf: 'center',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 5,
    width: 70,
    height: 70,
  },
  iconContainer: {
    flex: 1,
    justifyContent: 'center',
    padding: 5,
  },
  modalTextContainer: {
    flex: 0.3,
    alignSelf: 'center',
    justifyContent: 'center',
    marginTop: 30,
    marginBottom: 10,
  },
  modalText: {
    textAlign: 'center',
    fontSize: 16,
    fontWeight: '500',
    lineHeight: 20,
    letterSpacing: 0.25,
  },
  errorText: {
    textAlign: 'center',
    fontSize: 14,
    fontWeight: '500',
    lineHeight: 20,
    letterSpacing: 0.25,
    color: '#F00',
  },

  textInput: {
    fontSize: 14,
    color: '#3f3a40',
    textAlign: 'left',
    borderColor: '#c9c9c9',
    backgroundColor: 'white',
    borderRadius: 20,
    height: 45,
    width: '90%',
    margin: 5,
    paddingHorizontal: 16,
    borderWidth: 1,
  },
  errorTextContainer: {
    padding: 8,
    borderColor: '#f5c6cb',
    backgroundColor: '#f8d7da',
    borderRadius: 8,
  },

  topRowOrderItemOnOrdersListLarge: {
    borderWidth: 1,
    borderColor: '#001C47',
    paddingVertical: 10,
    alignSelf: 'center',
    width: '90%',
    borderRadius: 10,
    marginHorizontal: 5,
    marginTop: 16,
  },

  topRowText: {
    fontSize: 14,
    fontWeight: '400',
    lineHeight: 20,
    textAlign: 'center',
    color: '#001C47',
  },

  confirmPaymentBtnDisabled: {
    backgroundColor: '#D9D9D9',
    color: '#6f6f6f',
    borderColor: '#c1bfbf',
  },
});
